import { useAuth } from 'react-oidc-context';
import { UserRoles } from 'app/constants/users';

type PossibleRoles = UserRoles.CANTON_WRITER_ROLE | UserRoles.CANTON_VIEWER_ROLE;

const getAuthRolesConfig = (): string | boolean | undefined => {
  const isProduction = process.env.NODE_ENV !== 'development';
  return isProduction ? window._env_?.AUTH_ROLES : import.meta.env.VITE_AUTH_ROLES;
};

const isAuthDisabled = (authRoles: unknown): boolean => {
  // Enforce roles by default (matching the backend's auth.roles default of true).
  // Only an explicit false / "false" disables gating.
  return authRoles === false || authRoles === 'false';
};

export const useRoles = () => {
  const { user } = useAuth();

  // Config first: when the roles feature is disabled for the deployment,
  // grant full access regardless of any roles claim in the token.
  const authRoles = getAuthRolesConfig();
  if (isAuthDisabled(authRoles)) {
    return {
      isAdmin: true,
      isUser: true,
    };
  }

  const roles: PossibleRoles[] = Array.isArray(user?.profile?.roles) ? (user?.profile.roles as PossibleRoles[]) : [];

  return {
    isAdmin: roles.includes(UserRoles.CANTON_WRITER_ROLE),
    isUser: roles.includes(UserRoles.CANTON_VIEWER_ROLE),
  };
};
